export default __webpack_public_path__ + "static/media/boxing.13ed3cb5.gif";